import { Injectable } from '@angular/core';
import { ICountry } from '../../interfaces/country/country-list.interface';
import { COUNTRY_LIST } from './country-list.data';
import { COUNTRY_LANG } from '@core/enums';

@Injectable({
  providedIn: 'root'
})
export class CountryListService {
  readonly #countries: ICountry[] = COUNTRY_LIST;

  get list(): ICountry[] {
    return [...this.#countries];
  }

  getCountryByCode(code: string): ICountry | undefined {
    return this.#countries.find(country => country.code === code.toUpperCase() || country.iso === code.toUpperCase());
  }

  getLanguageList(): string[] {
    return Object.values(COUNTRY_LANG);
  }
}
